class Accordion {
    constructor() {
        var $this = this;

        $(document).ready(function() {
            $(".accordion").each(function() {
                $this.initializeBlock($(this));
            });
        });

        if (window.acf) {
            window.acf.addAction("render_block_preview", function(
                $block,
                props
            ) {
                if (props.name === "acf/accordion") {
                    $this.initializeBlock($block.find(".accordion"));
                }
            });
        }
    }

    initializeBlock($accordion) {
        $accordion.find(".toggle").click(function() {
            // Show the content
            $accordion.toggleClass("-open");
            $accordion.find(".content").slideToggle();

            // Set aria-expanded attribute
            var currentExpanded = $(this).attr("aria-expanded");
            currentExpanded === "true"
                ? $(this).attr("aria-expanded", "false")
                : $(this).attr("aria-expanded", "true");
        });
    }
}

export default Accordion;
